import React, {useCallback} from 'react';
import {Link} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import useFetchCards from 'app/games/whoisit/hooks/useFetchCards';
import openModal from 'app/modal/actions/open';
import { FullPageSpinner } from 'app/spinner';
import AdminWhoisitCards from 'app/admin/whoisit/cards'
import CreateCard from 'app/admin/whoisit/cards/modal/create';
import { ReactComponent as IconPlus } from 'assets/icon/plus.svg';
import 'app/admin/whoisit/index.css';
import {PATH_ADMIN} from "app/routes";

function WhoisitAdmin() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleCreateCard = useCallback(() => dispatch(openModal(CreateCard)), [dispatch]);
  const isLoadingCards = useFetchCards();

  if (isLoadingCards) {
    return <FullPageSpinner />;
  }

  return (
    <div className="AdminWhoisit">
      <div className="AdminWhoisitLinks">
        <Link to={PATH_ADMIN} className="BackToAdmin button medium secondary">
          {t('admin.backToAdmin')}
        </Link>
        <button className="AdminWhoisitCreateCard button medium primary" onClick={handleCreateCard}>
          <IconPlus className="AdminWhoisitCreateCardIcon" />
          {t('admin.whoisit.cards.createCard')}
        </button>
      </div>
      <div className="AdminWhoisitCardsWrapper">
        <h1>{t('admin.whoisit.cards.title')}</h1>
        <AdminWhoisitCards />
      </div>
    </div>
  );
}

export default WhoisitAdmin;
